package com.wintermar.inspection.core.ui.component.connectivity_monitor.util

enum class ConnectivityMonitorStatus {
    CONNECTED,
    DISCONNECTED,
    UNKNOWN
}
